// Persist MPAA values in uppercase.
const mpaaRatingOptions = [
  { label: 'G', value: 'G' },
  { label: 'PG', value: 'PG' },
  { label: 'PG-13', value: 'PG-13' },
  { label: 'R', value: 'R' },
  { label: 'NC-17', value: 'NC-17' },
  { label: 'TV-Y', value: 'TV-Y' },
  { label: 'TV-Y7', value: 'TV-Y7' },
  { label: 'TV-G', value: 'TV-G' },
  { label: 'TV-PG', value: 'TV-PG' },
  { label: 'TV-14', value: 'TV-14' },
  { label: 'TV-MA', value: 'TV-MA' },
];
// Persist BBFC values in uppercase so VNSelect matches tags extracted as U/PG/12A/R18.
const bbfcRatingOptions = [
  { label: 'U', value: 'U' },
  { label: 'PG', value: 'PG' },
  { label: '12', value: '12' },
  { label: '12A', value: '12A' },
  { label: '15', value: '15' },
  { label: '18', value: '18' },
  { label: 'R18', value: 'R18' },
];
const europeanFskRatingOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
  { label: '18', value: '18' },
];
const geoBlockingOptions = [
  { label: 'No geoblocking', value: 'NoGeoblocking' },
  { label: 'Allow in the following countries', value: 'AllowInTheFollowingCountries' },
  { label: 'Block in the following countries', value: 'BlockInTheFollowingCountries' },
];

const ShareContentOptions = [
  { label: 'No sharing', value: 'Nosharing' },
  { label: 'Share with Parent', value: 'ShareWithParent' },
  { label: 'Share with Parent and siblings OUs', value: 'Share withParent and siblings OUs' },
];

// Catalog casing for genre: tags (horror -> Horror). Shared with extractCommonTags.
const genreOptions = [
  { label: 'Action', value: 'Action' },
  { label: 'Adult', value: 'Adult' },
  { label: 'Adventure', value: 'Adventure' },
  { label: 'Animation', value: 'Animation' },
  { label: 'Biography', value: 'Biography' },
  { label: 'Comedy', value: 'Comedy' },
  { label: 'Crime', value: 'Crime' },
  { label: 'Documentary', value: 'Documentary' },
  { label: 'Drama', value: 'Drama' },
  { label: 'Family', value: 'Family' },
  { label: 'Fantasy', value: 'Fantasy' },
  { label: 'Film Noir', value: 'Film Noir' },
  { label: 'Game Show', value: 'Game Show' },
  { label: 'History', value: 'History' },
  { label: 'Horror', value: 'Horror' },
  { label: 'Musical', value: 'Musical' },
  { label: 'Music', value: 'Music' },
  { label: 'Mystery', value: 'Mystery' },
  { label: 'News', value: 'News' },
  { label: 'Reality-TV', value: 'Reality-TV' },
  { label: 'Romance', value: 'Romance' },
  { label: 'Sci-Fi', value: 'Sci-Fi' },
  { label: 'Short', value: 'Short' },
  { label: 'Sport', value: 'Sport' },
  { label: 'Talk-Show', value: 'Talk-Show' },
  { label: 'Thriller', value: 'Thriller' },
  { label: 'War', value: 'War' },
  { label: 'Western', value: 'Western' },
];

const newSeasonIdPrefix = 'temp-';

export {
  bbfcRatingOptions,
  europeanFskRatingOptions,
  genreOptions,
  geoBlockingOptions,
  mpaaRatingOptions,
  newSeasonIdPrefix,
  ShareContentOptions,
};
